import React, { useEffect } from 'react';
import './App.css';
import { initializeAnalytics } from './utils/analytics';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import TutorialPage from './pages/TutorialPage';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Companies from './pages/Companies';
import Deals from './pages/Deals';
import Marketing from './pages/Marketing';
import Tasks from './pages/Tasks';
import Reports from './pages/Reports';
import ImportExport from './pages/ImportExport';
import Activities from './pages/Activities';
import Settings from './pages/Settings';
import AdminDashboard from './pages/AdminDashboard';
import AIInsights from './pages/AIInsights';
import AIInsightsSimple from './pages/AIInsightsSimple';
import AIInsightsNew from './pages/AIInsightsNew';
import BillingPage from './pages/BillingPage';
import BillingSuccess from './pages/BillingSuccess';
import BillingCancel from './pages/BillingCancel';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import RefundPolicy from './pages/RefundPolicy';
import DataProcessingAgreement from './pages/DataProcessingAgreement';
import BetaSignup from './pages/BetaSignup';
import BetaThankYou from './pages/BetaThankYou';

function App() {
  useEffect(() => {
    // Initialize analytics when app loads
    initializeAnalytics();
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tutorial" element={<TutorialPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <PrivateRoute>
                <Layout>
                  <Contacts />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/contacts/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <ContactDetail />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <PrivateRoute>
                <Layout>
                  <Companies />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/deals"
            element={
              <PrivateRoute>
                <Layout>
                  <Deals />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/marketing"
            element={
              <PrivateRoute>
                <Layout>
                  <Marketing />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/tasks"
            element={
              <PrivateRoute>
                <Layout>
                  <Tasks />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Layout>
                  <Reports />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/activities"
            element={
              <PrivateRoute>
                <Layout>
                  <Activities />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/import-export"
            element={
              <PrivateRoute>
                <Layout>
                  <ImportExport />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Layout>
                  <Settings />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <PrivateRoute>
                <Layout>
                  <BillingPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="/billing/cancel" element={<BillingCancel />} />
          <Route
            path="/ai-insights"
            element={
              <PrivateRoute>
                <Layout>
                  <AIInsightsNew />
                </Layout>
              </PrivateRoute>
            }
          />
          {/* Beta Pages */}
          <Route path="/beta" element={<BetaSignup />} />
          <Route path="/beta/thank-you" element={<BetaThankYou />} />
          {/* Legal Pages */}
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/refunds" element={<RefundPolicy />} />
          <Route path="/dpa" element={<DataProcessingAgreement />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </ThemeProvider>
  );
}

export default App;